import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { Row, RegistryModel } from 'shared/lib';

export type RegistryBottomBarProps = ComponentPropsWithoutRef<'div'>;

export const createRegistryBottomBar = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
>(
	model: RegistryModel<TRow, TFilters, TError>,
) => {
	const RegistryBottomBar = forwardRef<HTMLDivElement, RegistryBottomBarProps>(
		({ children, className, ...props }, ref) => {
			const [empty, rowsEmpty] = useUnit([model.$empty, model.$rowsEmpty]);

			return (
				!empty &&
				!rowsEmpty && (
					<div
						ref={ref}
						className={clsx('registry-bottom-bar', className)}
						{...props}
					>
						{children}
					</div>
				)
			);
		},
	);

	return RegistryBottomBar;
};
